var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleVitalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5502 2H9.4502C7.6502 2 7.2502 2.9 7.0202 4.01L6.2002 7.93H17.8002L16.9802 4.01C16.7502 2.9 16.3502 2 14.5502 2Z",
    stroke: "#8B8C9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5.75H5.47M18.53 5.75H17.8M7.65 10.83H9.82M14.18 10.83H16.35M12 17V18M12 21V22M3 18L2 22M21 18L22 22M19.24 14.32C19.32 15.17 18.64 15.9 17.77 15.9H16.41C15.63 15.9 15.52 15.57 15.38 15.15L15.23 14.72C15.03 14.13 14.9 13.73 13.85 13.73H10.14C9.1 13.73 8.94 14.18 8.76 14.72L8.61 15.15C8.47 15.56 8.36 15.9 7.58 15.9H6.22C5.35 15.9 4.67 15.17 4.75 14.32L5.16 9.9C5.26 8.81 5.47 7.92 7.37 7.92H16.62C18.52 7.92 18.73 8.81 18.83 9.9L19.24 14.32Z",
    stroke: "#8B8C9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleVitalIcon);
export default __webpack_public_path__ + "static/media/vehicle-vital-icon.2cd7bd48167cd7f64bbabf929eb9df2b.svg";
export { ForwardRef as ReactComponent };